function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhlokkLogoSm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.715027,0,0,0.715027,12.5,12.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Phlokk_logo_md.svg",
    transform: "matrix(1,0,0,1,-15,-15)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(39.9425,0,0,39.9425,3.81608,20.3323)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0.279,-0C0.257,-0 0.237,-0.002 0.218,-0.007L0.243,-0.108C0.254,-0.104 0.266,-0.102 0.279,-0.102C0.299,-0.102 0.318,-0.106 0.336,-0.114C0.354,-0.121 0.37,-0.132 0.383,-0.145C0.396,-0.158 0.407,-0.174 0.415,-0.192C0.422,-0.21 0.426,-0.229 0.426,-0.25C0.426,-0.27 0.422,-0.289 0.415,-0.307C0.407,-0.324 0.396,-0.34 0.383,-0.353C0.37,-0.366 0.354,-0.377 0.336,-0.385C0.318,-0.392 0.299,-0.396 0.279,-0.396C0.259,-0.396 0.24,-0.392 0.222,-0.385C0.204,-0.377 0.188,-0.366 0.175,-0.353C0.162,-0.34 0.151,-0.324 0.144,-0.307C0.136,-0.289 0.132,-0.27 0.132,-0.25L0.132,0.233L0.03,0.13L0.03,-0.25C0.03,-0.284 0.037,-0.316 0.05,-0.347C0.063,-0.377 0.08,-0.403 0.103,-0.426C0.125,-0.449 0.151,-0.467 0.182,-0.48C0.212,-0.493 0.244,-0.5 0.279,-0.5C0.313,-0.5 0.345,-0.493 0.376,-0.48C0.407,-0.467 0.433,-0.449 0.456,-0.426C0.479,-0.403 0.497,-0.377 0.51,-0.347C0.523,-0.316 0.53,-0.284 0.53,-0.25C0.53,-0.215 0.523,-0.183 0.51,-0.153C0.497,-0.122 0.479,-0.096 0.456,-0.073C0.433,-0.05 0.407,-0.033 0.376,-0.02C0.345,-0.007 0.313,-0 0.279,-0Z",
    style: {
      fill: "rgb(255,0,0)",
      fillRule: "nonzero"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhlokkLogoSm);
export default __webpack_public_path__ + "static/media/Phlokk_logo_sm.cf73654a9e0d2afb5730ef470f74255f.svg";
export { ForwardRef as ReactComponent };